import React, { useState, useRef, useEffect } from 'react';
import { View, FlatList, ScrollView, Image, TouchableOpacity, Text, Animated, StyleSheet } from 'react-native';
import { useBoundStore } from '@/services/zustand/Store';

import 'keen-slider/keen-slider.min.css';
import '@/components/styles/webKeenSlider.css';
import { KeenSliderPlugin, useKeenSlider } from 'keen-slider/react';
import { pageFiles } from '@/services/Datatypes';


const MutationPlugin: KeenSliderPlugin = (slider) => {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            slider.update()
        })
    });
    const config = { childList: true }

    slider.on("created", () => {
        observer.observe(slider.container, config)
    });

    slider.on("destroyed", () => {
        observer.disconnect()
    });
};

const Arrow = (props: {
    disabled: boolean
    left?: boolean
    onClick: (e: any) => void
}) => {
    const disabled = props.disabled ? "arrow--disabled" : ""
    return (
        <svg
            onClick={props.onClick}
            className={`arrow ${props.left ? "arrow--left" : "arrow--right"
                } ${disabled}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            {props.left && (
                <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
            )}
            {!props.left && (
                <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
            )}
        </svg>
    )
};

const SliderControlComponent = (props: {
    instanceRef: any,
    numPages: number,
}) => {
    const currentPage: number = useBoundStore((state) => state.currentPage);

    return (
        <>
            <Arrow
                left
                onClick={(e: any) =>
                    e.stopPropagation() || props.instanceRef.current?.prev()
                }
                disabled={(currentPage - 1) === 0}
            />

            <Arrow
                onClick={(e: any) =>
                    e.stopPropagation() || props.instanceRef.current?.next()
                }

                disabled={
                    //currentSlide === instanceRef.current?.track.details.slides.length - 1
                    (currentPage - 1) === (props.numPages - 1)
                }
            //style={[styles.arrow]}
            />
        </>
    )
};

export const getPageImage = async (date: any, edition: any, pageNo: number, image: any) => {

    return new Promise(async (resolve, reject) => {

        const articleImageData: any = await fetch(
            '/web-server-api/getImage',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "type": 'pageImage',
                    "date": date,
                    "edition": edition,
                    "pageNo": pageNo,
                    "image": image
                }),
            }
        );

        const data = await articleImageData.json();
        const imageBase64 = data.base64ImageStr;

        if (imageBase64) {
            resolve({ uri: `${imageBase64}` });
        }
        else {
            reject(false);
        }
    });



};

export default function PageNavigation(props: { magazineDataForViewer: pageFiles[] }) {
    const origin = window.location.origin;

    const currentMagazine = useBoundStore((state) => state.magazine);
    const interstitialData = useBoundStore((state) => state.interstitialData);
    const currentPage = useBoundStore((state) => state.currentPage);
    const updateCurrentPage = useBoundStore((state) => state.updateCurrentPage);
    const numberOfPages = useBoundStore((state) => state.numberOfPages);
    const [numPages, setNumPages] = useState(0);
    const [modalOpen, setModalOpen] = useState(true);
    const [visiblePage, setVisiblePage] = useState(1);
    const slideAnim = useRef(new Animated.Value(270)).current;
    const [currentIndex, setCurrentIndex] = useState(1);

    const flatListRef = useRef<FlatList>(null);
    const scrollListRef = useRef<ScrollView>(null);

    const [sliderLoaded, setSliderLoaded] = useState(false);
    //const [currentSlide, setCurrentSlide] = useState(0);

    const [sliderPNRef, instancePNRef] = useKeenSlider({
        renderMode: 'performance',
        slides: {
            perView: 'auto',
            spacing: 10,
        },
        slideChanged(slider) {
        },
        created(slider) {
            setSliderLoaded(true);
            slider.moveToIdx(18);
        },
        updated() {
        },
    }, [MutationPlugin]);

    const [listItem, setListItem] = useState([]);
    const [isVisible, setIsVisible] = useState(false);

    const toggleModal = () => {
        //console.log('ViewerComponent.web - toggleModal');
        if (!modalOpen) {
            setIsVisible(true);
            setModalOpen(true);
            if (!instancePNRef.current || !instancePNRef.current.track?.details) return;
            instancePNRef.current.moveToIdx((visiblePage));
        }
        else {
            setIsVisible(false);
            setModalOpen(false);
        }
    }

    const handleNavigationPress = (page: number) => {
        //instanceRef.current?.moveToIdx((page - 1));
        updateCurrentPage(page - 1);
        //emitEvent('PageSelectionByNavigation', page);
    }

    useEffect(() => {
        //console.log("PageNavigation.web - useEffect currentPage", currentPage)
        if (modalOpen === true) {
            toggleModal()
        }
        setVisiblePage(currentPage - 1);
    }, [currentPage])

    useEffect(() => {
        if (!instancePNRef.current || !instancePNRef.current.track?.details) return;
        //console.log("PageNavigation.web - useEffect visiblePage", visiblePage);
        instancePNRef.current.moveToIdx((visiblePage));
    }, [visiblePage, modalOpen])

    const renderContent = (item: any, index: number) => {
        return (
            <View>
                <TouchableOpacity onPress={() => handleNavigationPress(index + 1)} style={styles.pageButton}>
                    <Text
                        style={{
                            color: '#000',
                            alignSelf: 'center',
                            fontSize: 10
                        }}
                    >{item.titel}</Text>
                    <Image style={{ maxWidth: 160, minWidth: 160, height: 220 }} source={item.image} />
                </TouchableOpacity>
            </View>
        )
    };

    const renderPageButton = ({ item, index }: { item: any, index: number }) => (
        <View>
            <TouchableOpacity onPress={() => handleNavigationPress(index + 1)} style={styles.pageButton}>
                <Text style={{ color: '#000', alignSelf: 'center', fontSize: 10 }}>{item.titel}</Text>
                <Image style={{ width: 160, height: 220 }} source={item.image} />
            </TouchableOpacity>
        </View>
    );

    useEffect(() => {
        if (currentMagazine) {
            //console.log('props.magazineDataForViewer', props.magazineDataForViewer);
            const buildList = async () => {

                let scrollViewItem: any = [];
                let add = 0;

                for (let i = 1; i <= (currentMagazine?.pageFiles?.length || 0); i++) {
                    let titel: string = "";
                    let image: any = "";
                    if (interstitialData !== null) {
                        if (interstitialData[0].page < i) {
                            add = -1;
                        } else if (interstitialData[0].page > i) {
                            add = 0
                        }
                        if (interstitialData[0].page === i) {
                            image = `https://cdn.duden.de/lexem_images/204279.png`;
                            titel = "Anzeige";
                        } else {
                            //image = `${origin}/protected-files/${currentMagazine?.date}/${i + add}/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                            //image = `${origin}/${currentMagazine?.date}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                            //image = `${origin}/${currentMagazine?.date}/${currentMagazine?.edition}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                            //image = `${FileSystem.documentDirectory}/epaper/${currentMagazine?.date}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                            image = await getPageImage(currentMagazine?.date, currentMagazine?.edition, i + add, `previewImageSmall.jpg`);
                            //console.log(image);
                            //titel = `Seite: ${i + add}`;
                            titel = `${props.magazineDataForViewer[(i - 1) + add].ressort}`;
                        }
                    }
                    if (interstitialData == null) {
                        //image = `${origin}/protected-files/${currentMagazine?.date}/${i + add}/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                        //image = `${origin}/${currentMagazine?.date}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                        //image = `${origin}/${currentMagazine?.date}/${currentMagazine?.edition}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                        //image = `${FileSystem.documentDirectory}/epaper/${currentMagazine?.date}/img/s_${currentMagazine?.date}.ZEITUNG.${currentMagazine?.edition}.${i + add}_0.jpg`;
                        //image = await getPageImage(currentMagazine?.date, currentMagazine?.edition, i + add, `previewImageSmall.jpg`);
                        //titel = `Seite: ${i + add}`;
                        image = await getPageImage(currentMagazine?.date, currentMagazine?.edition, i + add, `previewImageSmall.jpg`);
                        //console.log(image);
                        titel = `${props.magazineDataForViewer[(i - 1) + add].ressort}`
                    }
                    //console.log("PageNavigation.web - scrollViewItem: ", { image, titel })
                    scrollViewItem.push({ image, titel });

                    if (i === currentMagazine?.pageFiles?.length) {
                        setNumPages(scrollViewItem.length);
                        setListItem(scrollViewItem);
                    }
                }
            }
            buildList();
        }
    }, [currentMagazine]);

    return (
        <View style={[styles.container]}>
            <View style={[styles.modalContent]}>
                <TouchableOpacity onPress={toggleModal} style={styles.openButton}>
                    <Text style={styles.textStyle}>Menü</Text>
                </TouchableOpacity>
                {isVisible &&
                    <View
                        //@ts-ignore
                        style={{
                            flex: 1,
                            width: '100vw'
                        }}
                    >
                        <div ref={sliderPNRef} className="keen-slider">

                            {
                                listItem.map((item: any, index: number) => (
                                    <div
                                        key={`pageNavigation_slide_${index + 1}`}
                                        className={`keen-slider__slide number-slide${index + 1}`}
                                        style={{ maxWidth: 160, minWidth: 160 }}
                                        onClick={() => handleNavigationPress(index + 1)}
                                    >
                                        {
                                            renderContent(item, index)
                                        }

                                    </div>

                                ))
                            }

                            {
                                /*
                                Array.from(
                                    new Array(numPages),
                                    (el, index) => (

                                        <div
                                            key={`pageNavigation_slide_${index + 1}`} 
                                            className={`keen-slider__slide number-slide${index + 1}`}
                                        >

                                        </div>
                                    )
                                )
                                */
                            }
                        </div>

                        {sliderLoaded && (
                            <>
                                <SliderControlComponent
                                    instanceRef={instancePNRef}
                                    numPages={numPages}
                                />
                            </>
                        )}
                    </View>
                }

            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        bottom: 0,
        alignItems: 'center',
        width: '100%',
        position: 'absolute',
    },
    openButton: {
        width: '100%',
        height: 45,
        padding: 3,
        backgroundColor: '#CCC',
    },
    modalContent: {
        flex: 1,
        bottom: 0,
        alignItems: 'center',
        width: '100%',
        height: 300,
        backgroundColor: '#fff',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
    },
    textStyle: {
        color: '#000',
        textAlign: 'center',
    },
    pageButton: {
        borderRadius: 5,
        margin: 4,
        padding: 2,
        backgroundColor: '#eee',
    },
});
